import { render, staticRenderFns } from "./faturadurumusorgula.vue?vue&type=template&id=634b8659"
import script from "./faturadurumusorgula.vue?vue&type=script&lang=js"
export * from "./faturadurumusorgula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports